import {getDatetimeFormatter} from '@cypro/ui/utils'
import {Timeline} from '@chakra-ui/react'
import {EventLog} from '@cypro/engine/schema'
import {useTranslate} from '@tolgee/react'
import {LuCheck, LuEye, LuPen, LuTrash} from 'react-icons/lu'
import {UserTag} from './tags/user-tag'
import {openLogDrawer} from '@/modules/system-logs/components/log-drawer/util'
import {getAdministrationLogKeys} from '@/modules/patients-therapies/administration-log'

const actionIcons = {
  create: <LuCheck />,
  update: <LuPen />,
  delete: <LuTrash />,
  access: <LuEye />,
} as const

const actionText = {
  create: 'created_by',
  update: 'updated_by',
  delete: 'deleted_by',
  access: 'accessed_by',
} as const

interface Props {
  activities: EventLog[]
}

export function ActivityTimeline({activities}: Props) {
  const {t} = useTranslate('common')

  return (
    <Timeline.Root size="xl">
      {activities.map(activity => (
        <Timeline.Item
          key={activity.id}
          onClick={() => openLogDrawer(activity)}
          cursor="pointer"
          px={4}
          transition="all 0.1s"
          borderLeft="3px solid transparent"
          _hover={{
            borderLeftColor: 'fg.subtle',
            transform: 'translateX(2px)',
          }}
        >
          <Timeline.Connector>
            <Timeline.Separator />
            <Timeline.Indicator bgColor="gray.muted" color="gray.fg">
              {activity.action && actionIcons[activity.action]}
            </Timeline.Indicator>
          </Timeline.Connector>
          <Timeline.Content>
            <Timeline.Title textStyle="sm">
              {activity.action && t(actionText[activity.action])}
              <UserTag user={activity.actor}>{activity.actor?.name}</UserTag>
            </Timeline.Title>
            <Timeline.Description>
              {[
                getDatetimeFormatter().format(activity.performedAt),
                ...getAdministrationLogKeys(activity.details).map(key => t(key)),
                // a release done by Auto-release for delivery, not by a person in QA & dispatch
                ...(activity.details?.automatic === 'true' ? [t('automatic_release')] : []),
              ].join(' · ')}
            </Timeline.Description>
          </Timeline.Content>
        </Timeline.Item>
      ))}
    </Timeline.Root>
  )
}
